import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ArchiveV3Service } from './api/archiveV3.service';
import { EcoV3Service } from './api/ecoV3.service';
import { LookupV3Service } from './api/lookupV3.service';
import { OpenJourneyPlannerV3Service } from './api/openJourneyPlannerV3.service';
import { PlacesV3Service } from './api/placesV3.service';
import { SchedulesV3Service } from './api/schedulesV3.service';
import { SituationsV3Service } from './api/situationsV3.service';
import { ToolSupportV3Service } from './api/toolSupportV3.service';
import { TripsSubscriptionV3Service } from './api/tripsSubscriptionV3.service';
import { TripsV2Service } from './api/tripsV2.service';
import { TripsV3Service } from './api/tripsV3.service';
import { VehicleJourneysV3Service } from './api/vehicleJourneysV3.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
